import CheckoutCollapse from '../Checkout.Collapse';
import { translate } from '../../Services/translation';
import CheckoutCoupon from '../Checkout.Coupon';
import React from 'react';

const RenderCouponSection = ({
  checkout,
  setCampaignCode,
  submitCampaignCode,
}) => {
  const { errors = {} } = checkout;
  return (
    <CheckoutCollapse title={translate('checkout.askcampaigncode')}>
      <CheckoutCoupon
        errors={errors}
        onCampaignCodeChange={setCampaignCode}
        onSubmitCampaignCode={submitCampaignCode}
      />
    </CheckoutCollapse>
  );
};

export default RenderCouponSection;
